import { render } from "./FilterBase.vue?vue&type=template&id=0aa76afc&ts=true"
import script from "./FilterBase.vue?vue&type=script&lang=ts"
export * from "./FilterBase.vue?vue&type=script&lang=ts"

import "./FilterBase.vue?vue&type=style&index=0&id=0aa76afc&lang=scss"

import exportComponent from "/Users/camp2/Devs/indicar/indicar-gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__